module.exports = __webpack_public_path__ + "static/media/06.0de05dce.mp3";